import initialState from '../state'

export default (state = initialState.nav, { type, page, data }) => {
	switch (type) {
	case 'ADD_PAGE': return [...state, { page, data }]
	case 'REMOVE_PAGE': return [...state.slice(0, -1)]
	case 'SET_PAGE': return [{ page, data }]
	case 'UPDATE_PAGE':
		state.pop()
		state.push({ page, data })
		return state
	default: return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/nav.js